import { OpenNewTabTargetType } from '@voltmoney/types';
import { ButtonTypeTokens, WIDGET, } from '@voltmoney/schema';
import { Links, PartnerFaqLink, partnerHelpLineNumber, PartnerLink, WhatsAppLink } from '../../configs/constants';
import { ROUTE } from '../../routes';
import { platformApi, StoreKey } from "../../configs/api";
import { getAuthHeaders } from "../../configs/config";
import md5 from 'md5';
import sharedPropsService from "../../SharedPropsService";
import { navigateByUrl } from "../dashboard/utils";
let platformCode = '';
let platformPassword = '';
let isWhatsAppEnabled = true;
export const getPlatformCode = async (action, _datastore, { setDatastore }) => {
    console.warn('**** PhoneNumberAction Triggered ****', action);
    platformCode = action.payload.value;
    if (platformCode !== '' && platformPassword !== '') {
        await setDatastore(ROUTE.PLATFORM_SIGN_UP, "verifyPlatformCTA", {
            type: ButtonTypeTokens.LargeFilled
        });
    }
    else {
        await setDatastore(ROUTE.PLATFORM_SIGN_UP, "verifyPlatformCTA", {
            type: ButtonTypeTokens.LargeOutline
        });
    }
};
export const getPlatformPassword = async (action, _datastore, { setDatastore }) => {
    platformPassword = action.payload.value;
    if (platformCode !== '' && platformPassword !== '') {
        await setDatastore(ROUTE.PLATFORM_SIGN_UP, "verifyPlatformCTA", {
            type: ButtonTypeTokens.LargeFilled
        });
    }
    else {
        await setDatastore(ROUTE.PLATFORM_SIGN_UP, "verifyPlatformCTA", {
            type: ButtonTypeTokens.LargeOutline
        });
    }
};
export const verifyPlatformDetails = async (action, _datastore, { network, asyncStorage, openNewTab, removeWidgets, setDatastore }) => {
    const MD5HasedPassword = md5(platformPassword);
    const authResponse = await network.post(`${platformApi.authLogin}`, {
        appPlatform: `${platformCode}`,
        passwordHash: `${MD5HasedPassword}`
    }, {
        headers: await getAuthHeaders()
    });
    if (authResponse.status === 200) {
        const auth_token = authResponse.data.jwt;
        await sharedPropsService.setToken(auth_token);
        asyncStorage.set(StoreKey.APP_PLATFORM, platformCode);
        await navigateByUrl(ROUTE.PLATFORM_DASHBOARD, openNewTab);
        removeWidgets(ROUTE.PLATFORM_SIGN_UP, [{ id: "spaceError", type: WIDGET.SPACE }, {
                id: "errorText", type: WIDGET.TEXT
            }]);
    }
    else {
        if (authResponse.response.data.voltErrorCode === 'IN_CORRECT_PLATFORM_LOGIN') {
            await setDatastore(ROUTE.PLATFORM_SIGN_UP, "errorTextStack", {
                hide: false
            });
        }
        await setDatastore(ROUTE.PLATFORM_SIGN_UP, "verifyPlatformCTA", {
            type: ButtonTypeTokens.LargeOutline
        });
    }
};
export const dummy = async (action, _datastore, { network, asyncStorage, openNewTab, removeWidgets, setDatastore }) => {
    const MD5HasedPassword = md5(platformPassword);
    const authResponse = await network.post(`${platformApi.authLogin}`, {
        appPlatform: `${platformCode}`,
        passwordHash: `${MD5HasedPassword}`
    }, {
        headers: await getAuthHeaders()
    });
    if (authResponse.status === 200) {
        const auth_token = authResponse.data.jwt;
        await sharedPropsService.setToken(auth_token);
        asyncStorage.set(StoreKey.APP_PLATFORM, platformCode);
        await navigateByUrl(ROUTE.PLATFORM_DASHBOARD, openNewTab);
        removeWidgets(ROUTE.PLATFORM_SIGN_UP, [{ id: "spaceError", type: WIDGET.SPACE }, {
                id: "errorText", type: WIDGET.TEXT
            }]);
    }
    else {
        if (authResponse.response.data.voltErrorCode === 'IN_CORRECT_PLATFORM_LOGIN') {
            await setDatastore(ROUTE.PLATFORM_SIGN_UP, "errorTextStack", {
                hide: false
            });
        }
        await setDatastore(ROUTE.PLATFORM_SIGN_UP, "verifyPlatformCTA", {
            type: ButtonTypeTokens.LargeOutline
        });
    }
};
export const ToggleCTA = async (action, _datastore, { setDatastore }) => {
    await setDatastore(action.routeId, action.payload.targetWidgetId, {
        type: action.payload.value
            ? ButtonTypeTokens.LargeFilled
            : ButtonTypeTokens.LargeOutline,
    });
};
export const GoToPrivacy = async (action, _datastore, { openNewTab }) => {
    console.warn('**** GoToPrivacy Triggered ****', action);
    openNewTab(Links.VOLT_PRIVACY, OpenNewTabTargetType.blank);
};
export const WhatsappToggle = async (action, _datastore) => {
    console.warn('**** WhatsappToggle Triggered ****', action);
    isWhatsAppEnabled = action.payload.value;
};
export const DisableSubmit = async (action, _datastore, { setDatastore }) => {
    await setDatastore(ROUTE.PARTNER_SIGNUP, "additionalDetailContinueBtn", {
        type: action.payload.value
            ? ButtonTypeTokens.LargeFilled
            : ButtonTypeTokens.LargeOutline,
    });
};
export const GoToHome = async (action, _datastore, { openNewTab }) => {
    openNewTab(`${PartnerLink}`, OpenNewTabTargetType.self);
};
export const GoToFaq = async (action, _datastore, { openNewTab, instrumentTrack }) => {
    instrumentTrack("FAQ_BUTTON_CLICKED");
    openNewTab(`${PartnerFaqLink}`, OpenNewTabTargetType.blank);
};
export const GoToWhatsapp = async (action, _datastore, { openNewTab, instrumentTrack }) => {
    instrumentTrack("CONTACT_VIA_WA_BUTTON_CLICKED");
    openNewTab(`${WhatsAppLink.helpPartner}`, OpenNewTabTargetType.blank);
};
export const GoToPhone = async (action, _datastore, { openNewTab, instrumentTrack }) => {
    instrumentTrack("CONTACT_VIA_CALL_BUTTON_CLICKED");
    openNewTab(`tel:+91${partnerHelpLineNumber}`, OpenNewTabTargetType.parent);
};
